// console.log("product-card not found, creating it now");
if (!customElements.get("product-card")) {
  customElements.define(
    "product-card",
    class ProductCard extends HTMLElement {
      constructor() {
        super();

        this.hasBeenInitialized = false;

        this.buyButtonText = {
          addToCart: "Add to Cart",
          soldOut: "Sold Out",
          extendedOffer: "Extended Offer",
          clickToBuy: "Click to Buy",
          viewMore: "View More",
        };

        this.isVariantCard =
          this.dataset.isVariantCard === "true" ? true : false;

        this.openModalToConfirmOnMobile =
          this.dataset.openModalToConfirm === "true" ? true : false;

        this.extendedOfferEnabled =
          this.dataset.extendOffer == "true" ? true : false;

        this.boundExtendedOfferHandler = this.extendedOfferHandler.bind(this);
        this.boundOnMobileButtonClick = this.onMobileButtonClick.bind(this);

        this.isLastProductCard =
          this.dataset.isLastProductCard === "true" ? true : false;

        this.optionSize = parseInt(this.dataset.optionSize || "0");

        this.hasImageUpload =
          this.dataset.hasImageUpload === "true" ? true : false;

        this.holidayShippingEnable =
          this.dataset.holidayShippingEnable === "true" ? true : false;
      }

      connectedCallback() {
        this.buyButtonText = {
          addToCart: this.dataset.textAddToCart || this.buyButtonText.addToCart,
          soldOut: this.dataset.textSoldout || this.buyButtonText.soldOut,
          extendedOffer:
            this.dataset.textExtendedOffer || this.buyButtonText.extendedOffer,
          clickToBuy:
            this.dataset.textClickToBuy || this.buyButtonText.clickToBuy,
          viewMore: this.dataset.textViewMore || this.buyButtonText.viewMore,
        };
        this.form =
          this.querySelector('form[id^="product-form-template"]') || null;

        /**
         * @type {HTMLInputElement | null}
         */
        this.addToCartButton = this.querySelector(".product-form__submit");

        /**
         * @type {HTMLInputElement | null}
         */
        this.variantInput = this.form
          ? this.form.querySelector('input[name="id"]')
          : null;

        this.variantDisplay = this.querySelector(".selected-variant-display");

        const productElement = /** @type {HTMLElement} */ (
          this.querySelector(".product-card-product")
        );
        if (!productElement) {
          console.log(
            "product not found, might be rendered on cbs-box section"
          );
          return;
        }

        const productJson = /** @type {string} */ productElement.textContent;

        /**
         * @type {HTMLElement | null}
         */
        this.holidayShippingElement = this.querySelector(
          "holiday-shipping-countdown"
        );

        /**
         * @type {Product}
         * */
        this.product = /** @type {Product} */ (
          JSON.parse(/** @type {string} */ (productJson))
        );

        if (!this.product) {
          console.error("product not found");
          return;
        }

        // Hidden variants plumbing (for single-option products)
        /** @type {Set<string>} */
        this.hiddenVariantIdSet = new Set();
        const hiddenEl = this.querySelector("#hidden-variant-ids");
        if (hiddenEl && hiddenEl.textContent) {
          try {
            const arr = JSON.parse(hiddenEl.textContent);
            if (Array.isArray(arr)) {
              this.hiddenVariantIdSet = new Set(arr.map((id) => id.toString()));
            }
          } catch (e) {
            console.error("error parsing hidden variant ids");
          }
        }

        this.variantCardVariant = null;
        this.variantInventoryQuantity = 0;
        if (this.isVariantCard) {
          const variantCardData = this.dataset.variantCardVariantId || null;

          let variantCardVariantId = 0;
          if (variantCardData) {
            variantCardVariantId = parseInt(variantCardData);
          }

          this.variantCardVariant = this.product.variants.find((variant) => {
            return variant.id === variantCardVariantId;
          });
          this.variantInventoryQuantity = parseInt(
            this.dataset.variantCardInventory || "0"
          );
        }

        this.hasCustomText =
          this.dataset.hasCustomText === "true" ? true : false;

        const shipsByElements = this.querySelectorAll(".ships-by-wrapper");

        /**
         * @type {HTMLElement[] | Array<any>}
         */
        this.shipsByElementsArray = shipsByElements
          ? Array.from(shipsByElements)
          : [];

        if (this.shipsByElementsArray.length === 0) {
          this.noShipsByElements = true;
        }

        /**
         * @type {HTMLElement | null}
         */
        this.soldOutElement = this.querySelector(".product__sold-out");
        this.hideSoldOutElement();

        // elements for dynamic price
        /**
         * @type {HTMLElement | null}
         */
        this.priceElement = this.querySelector(".price");

        const regularPriceElements = this.querySelectorAll(
          ".price-item--regular"
        );
        this.regularPriceElementsArray = regularPriceElements
          ? Array.from(regularPriceElements)
          : [];

        const salePriceElemets = this.querySelectorAll(".price-item--sale");
        this.salePriceElementsArray = salePriceElemets
          ? Array.from(salePriceElemets)
          : [];

        // elements for dynamic discount badge
        this.specialOfferEnabled =
          this.dataset.specialOfferEnabled === "true" ? true : false; // move to card data attributes

        /**
         * @type {HTMLElement | null}
         */
        this.discountBadge = this.querySelector(".discount-badge");

        /**
         * @type {HTMLElement | null}
         */
        this.discountBadgeText = this.querySelector(".discount-badge__text");

        /**
         * @type {HTMLElement | null}
         */
        this.specialOfferBadge = this.querySelector(".special");

        /**
         * @type {HTMLElement | null}
         */
        this.exclusiveOfferBadge = this.querySelector(".exclusive");

        if (this.product.variants.length > 1 && this.variantInput) {
          // Input only exists if we have a product with more than one variant
          this.variantInput.addEventListener("change", (event) => {
            const target = /** @type {HTMLInputElement} */ (event.target);
            const variantId = target.value;
            this.variantChangeHandler(variantId);
          });
        }

        this.productId = this.product ? this.product.id.toString() : null;
        this.getVariantInventory();
        // console.log('product: ', this.product);

        // Ships By
        /**
         * @type {HTMLInputElement | null}
         */
        this.shipsByInput = this.querySelector("#ships-by-input");
        // console.log(
        //   `ships by input for ${this.product.title}: ${this.shipsByInput}`
        // );

        // Ships by refactored
        this.shipsByDate = knocking.getTagShippingDate(this.product.tags);
        if (this.shipsByInput) {
          this.setShipsBy(this.shipsByDate);
        } else if (!this.holidayShippingEnable) {
          console.log("No ships by input found, initializing variant state...");
          this.initVariantState();
        }

        window.addEventListener("message", (event) => {
          if (
            event.data.type === "ships_by_notification_ready" &&
            this.productId === event.data.productId.toString()
          ) {
            // console.log("ships_by_notification_ready: ", event.data);
            if (this.hasBeenInitialized) {
              return;
            }

            if (
              this.isVariantCard &&
              this.variantCardVariant &&
              this.variantCardVariant.id !== parseInt(event.data.variantId)
            ) {
              console.log(
                "is variant card and variant card variant id is not the same as the event data variant id"
              );
              return;
            }
            console.log("initVariantState");
            this.initVariantState();
          }
        });

        // Sync inputs on card and modal
        messenger.listen(
          messenger.topics.SET_VARIANT_INPUT_ON_PRODUCT_CARD,
          /**
           * @param {SetVariantInputOnProductCardPayload} data
           */
          (data) => {
            // console.log(
            //   "set variant on product card - this.productId: ",
            //   this.productId
            // );
            if (!this.productId || this.isVariantCard) return;
            if (data.productId === this.productId) {
              // console.log('setting variant on product card: ', data.variantId);
              if (!this.addToCartButton) {
                console.error("cannot find addToCartButton");
                return;
              }
              const resetButtonType = this.addToCartButton.classList.contains(
                "HS-expired"
              )
                ? false
                : true;
              // console.log('resetButtonType: ', resetButtonType);
              this.variantChangeHandler(data.variantId, resetButtonType);
            }
          }
        );

        // Close all mobile modals on openCart
        messenger.listen(messenger.topics.OPEN_CART, () => {
          this.closeAllMobileVariantSwipers();
        });

        messenger.listen(
          messenger.topics.SET_THIS_CARD_BUTTON_TO_SOLD_OUT,
          (data) => {
            if (data && data.productId) {
              if (data.productId === this.productId) {
                this.setSoldOutUI();
              }
            }
          }
        );

        // change product card image
        messenger.listen(
          messenger.topics.CHANGE_PRODUCT_CARD_IMAGE,
          /**
           * @param {ChangeProductCardImagePayload} data
           */
          (data) => {
            // console.log('CHANGE_PRODUCT_CARD_IMAGE: ', data);
            const index = parseInt(data.index);
            const productId = data.productId;
            const variantId = data.variantId;

            if (productId == this.productId) {
              // const productImages = Array.from(this.querySelector('.media').querySelectorAll('[data-product-image]'));
              /**
               * @type {HTMLElement | null}
               */
              const mediaVariants = this.querySelector(".media--variants");
              if (!mediaVariants) {
                console.log("cannot find media--variants");
                return;
              }
              const variantImages = Array.from(
                mediaVariants.querySelectorAll("img")
              );
              /**
               * @type {HTMLElement | null}
               */
              const productImagesWrapper =
                this.querySelector(".media--product");
              /**
               * @type {HTMLElement | null}
               */
              const variantImagesWrapper =
                this.querySelector(".media--variants");

              if (!productImagesWrapper || !variantImagesWrapper) {
                return;
              }

              const selectedVariantImage = variantImages.find((image) => {
                const datasetVariantId = image.dataset.variantId;
                if (!datasetVariantId) {
                  console.error("datasetVariantId not found");
                  return false;
                }
                return datasetVariantId === variantId;
              });

              if (selectedVariantImage) {
                for (const image of variantImages) {
                  image.style.display = "none";
                }
                productImagesWrapper.style.display = "none";
                variantImagesWrapper.style.display = "block";
                selectedVariantImage.style.display = "block";
                selectedVariantImage.style.opacity = "1";
              } else {
                variantImagesWrapper.style.display = "none";
                productImagesWrapper.style.display = "block";
              }

              if (!this.hasBeenInitialized) {
                this.initVariantState();
              }
            }
          }
        );

        // Variant Swiper
        /** @type {HTMLElement | null}
         */
        this.swiperElementDesktop = this.querySelector(
          "swiper-variants-desktop"
        );
        /**
         * @type {HTMLElement | null}
         */
        this.swiperMobileButton = this.querySelector(
          ".open-variant-swiper-button"
        );
        const mobileVariantSwipersElements = document.querySelectorAll(
          "swiper-variants-mobile"
        );
        /**
         * @type {HTMLElement[] | Array<any>}
         */
        this.mobileVariantSwipersArray = mobileVariantSwipersElements
          ? Array.from(mobileVariantSwipersElements)
          : [];

        if (this.swiperMobileButton) {
          this.swiperMobileButton.addEventListener("click", (event) => {
            this.onMobileButtonClick(event);
          });
        }

        if (this.isLastProductCard) {
          messenger.emmit(messenger.topics.LAST_PRODUCT_CARD_READY);
        }

        // Ships by elments might not be present because of holiday shipping. ships by ready message will not be sent.
        if (this.noShipsByElements) {
          this.initVariantState();
        }

        if (!this.hasBeenInitialized) {
          this.initVariantState();
        }
      }

      initVariantState() {
        if (!this.product) {
          console.error("product not found");
          return;
        }
        // Use only visible variants when product has a single option
        let candidateVariants = this.product.variants;
        if (this.optionSize === 1 && this.hiddenVariantIdSet) {
          candidateVariants = this.product.variants.filter(
            (v) => !this.hiddenVariantIdSet.has(v.id.toString())
          );
        }

        // Prefer first in-stock (inventoryQuantity > 0), then available, then any visible
        let firstAvailableVariant = candidateVariants.find(
          (variant) => (variant.inventoryQuantity || 0) > 0
        );

        if (!firstAvailableVariant) {
          firstAvailableVariant = candidateVariants.find(
            (variant) => variant.available === true
          );
        }

        if (!firstAvailableVariant) {
          firstAvailableVariant = candidateVariants[0];
        }

        // If all variants are hidden, set sold out UI and stop
        if (!firstAvailableVariant) {
          this.setSoldOutUI();
          this.hasBeenInitialized = true;
          return;
        }
        let variantId;
        if (this.isVariantCard && this.variantCardVariant) {
          variantId = this.variantCardVariant.id.toString();
        } else {
          variantId = firstAvailableVariant.id.toString();
        }

        if (!variantId) {
          console.error("no variantId found");
          return;
        }

        // console.log("------------------------------------------------");
        // console.log("Initializing product-card: ", this.product.title);
        // console.log("Is variant-card: ", this.isVariantCard);
        const variant = this.product.variants.find(
          (variant) => variant.id === parseInt(variantId)
        );
        // console.log("Variant: ", variant.title);
        // console.log("qty: ", variant?.inventoryQuantity);

        this.variantChangeHandler(variantId);

        messenger.emmit("CHANGE_PRODUCT_CARD_IMAGE", {
          productId: this.product.id,
          variantId,
        });

        this.hasBeenInitialized = true;
      }

      setInitialButtonState() {
        if (this.openModalToConfirmOnMobile) {
          // this.setAddToCartButtonToButton;
        }
      }

      /**
       * @param {string} variantId
       * @param {boolean} resetButtonType
       * @returns {void}
       * */
      variantChangeHandler(variantId, resetButtonType = true) {
        // console.log("variant change handler: ", variantId);
        if (!this.product) {
          console.error("product not found");
          return;
        }
        /**
         * @type {Variant | undefined}
         * */
        let currentVariant = this.product.variants.find((variant) => {
          return variant.id.toString() === variantId;
        });

        // Guard: if hidden selection on single-option product, fallback to first visible
        if (
          this.optionSize === 1 &&
          this.hiddenVariantIdSet &&
          currentVariant &&
          this.hiddenVariantIdSet.has(currentVariant.id.toString())
        ) {
          const visible = this.product.variants.filter(
            (v) => !this.hiddenVariantIdSet.has(v.id.toString())
          );
          const fallback = visible.find((v) => v.available) || visible[0];
          if (fallback) {
            this.variantChangeHandler(fallback.id.toString(), resetButtonType);
            return;
          } else {
            this.setSoldOutUI();
            return;
          }
        }

        if (!currentVariant) {
          console.error("currentVariant not found");
          return;
        }
        if (this.isVariantCard && this.variantInventoryQuantity) {
          currentVariant.inventoryQuantity = this.variantInventoryQuantity;
        }

        this.hideSoldOutElement();
        if (this.holidayShippingElement) {
          this.holidayShippingElement.style.display = "block";
        }

        // console.log('quantity: ', currentVariant.quantity);
        // console.log('policy: ', currentVariant.policy);
        // console.log('extendOffer: ', this.extendOffer);

        if (this.variantInput) {
          this.variantInput.value = variantId;
        }
        if (!currentVariant) {
          console.error("cannot find currentVariant");
          return;
        }

        if (currentVariant.inventoryQuantity > 0) {
          if (
            this.optionSize > 1 ||
            this.hasCustomText ||
            this.hasImageUpload
          ) {
            this.setClickToBuyUI();
          } else {
            this.setAddToCartUI();
          }
        } else {
          if (this.extendedOfferEnabled) {
            if (this.optionSize > 1 || this.hasCustomText) {
              this.setExtendedOfferUI(true);
            } else {
              this.setExtendedOfferUI(false);
            }
          } else if (this.product.tags.includes("cbs-box")) {
            this.setViewMoreUI();
          } else {
            this.setSoldOutUI();
          }
        }

        this.displaySelectedVariant(currentVariant);
        this.updateDiscountBadge(currentVariant);
        this.updatePrice(currentVariant);
        this.updateProductUrls(currentVariant.id);
      }

      /**
       * @param {Variant} variant
       * @returns {void}
       */
      updateDiscountBadge(variant) {
        // console.log(
        //   `updateDiscountBadge for product ${this.productId} with variant ${variant.id}
        //   `,
        //   variant
        // );

        const discount = knocking.calculateDiscountPercent(variant);
        if (discount === "Exclusive Offer") {
          // console.log("discount is Exclusive Offer");
          this.showExclusiveOffer();
          return;
        } else if (
          typeof discount === "number" &&
          discount <= 20 &&
          this.specialOfferEnabled
        ) {
          this.showSpecialOffer();
          return;
        } else if (this.discountBadgeText) {
          this.discountBadgeText.textContent = discount.toString();
          this.showDiscountBadge();
        }
      }

      badgesArePresent() {
        return (
          this.discountBadge &&
          this.specialOfferBadge &&
          this.exclusiveOfferBadge
        );
      }

      showDiscountBadge() {
        if (
          !this.discountBadge ||
          !this.specialOfferBadge ||
          !this.exclusiveOfferBadge
        )
          return;
        this.discountBadge.style.display = "flex";
        this.specialOfferBadge.style.display = "none";
        this.exclusiveOfferBadge.style.display = "none";
      }

      showExclusiveOffer() {
        if (
          !this.discountBadge ||
          !this.specialOfferBadge ||
          !this.exclusiveOfferBadge
        )
          return;
        this.discountBadge.style.display = "none";
        this.specialOfferBadge.style.display = "none";
        this.exclusiveOfferBadge.style.display = "flex";
      }

      showSpecialOffer() {
        if (
          !this.discountBadge ||
          !this.specialOfferBadge ||
          !this.exclusiveOfferBadge
        )
          return;
        this.discountBadge.style.display = "none";
        this.specialOfferBadge.style.display = "flex";
        this.exclusiveOfferBadge.style.display = "none";
      }

      /**
       * @param {Variant} variant
       * @returns {void}
       */
      updatePrice(variant) {
        const { price, compare_at_price } = variant;
        if (
          compare_at_price &&
          this.priceElement &&
          this.regularPriceElementsArray
        ) {
          this.priceElement.classList.add("price--on-sale");
          for (const element of this.regularPriceElementsArray) {
            element.textContent = `${knocking.formatToDollarCurrencyString(
              compare_at_price.toString()
            )}`;
          }
        } else if (this.priceElement && this.regularPriceElementsArray) {
          this.priceElement.classList.remove("price--on-sale");
          for (const element of this.regularPriceElementsArray) {
            element.textContent = `${knocking.formatToDollarCurrencyString(
              price
            )}`;
          }
        }

        if (this.salePriceElementsArray) {
          for (const element of this.salePriceElementsArray) {
            element.textContent = `${knocking.formatToDollarCurrencyString(
              price
            )}`;
          }
        }
      }

      /**
       * @param {string} state
       */
      setStateOnMobileVariantSelectCP(state) {
        messenger.emmit(
          messenger.topics.SET_STATE_ON_MOBILE_VARIANT_SELECT_CP,
          {
            state,
            productId: this.productId,
            text: this.buyButtonText[state] || "",
          }
        );
      }

      /**
       * @param {Variant} variant
       */
      displaySelectedVariant(variant) {
        // console.log('displaySelectedVariant: ', this.variantDisplay);
        if (!this.variantDisplay) {
          return;
        }
        this.variantDisplay.textContent = variant.title;
      }

      // Can probably be removed
      appendVariantInfoToProduct() {
        /**
         * @type {HTMLElement | null}
         */
        const variantQuantities = this.querySelector("#variant-quantities");
        if (!variantQuantities) {
          console.error("can not find variantQuantities element");
          return;
        }
        const variantQuantitiesArray = variantQuantities.textContent
          ? variantQuantities.textContent.split("/")
          : [];

        if (!this.product) {
          console.error("Cannot find product id to determine variantPolicies");
          return;
        }
        /**
         * @type {HTMLElement | null}
         */
        const variantPolicies = this.querySelector(
          `#variant-inventory-policies-${this.product.id}`
        );
        const variantPoliciesArr = variantPolicies?.textContent
          ? variantPolicies.textContent.split("/")
          : [];
        for (let i = 0; i < this.product.variants.length; i++) {
          if (!variantPoliciesArr[i]) {
            continue;
          }
          const variant = this.product.variants[i];
          variant.quantity = parseInt(variantQuantitiesArray[i]);
          if (variantPoliciesArr[i].length > 0) {
            variant.policy = variantPoliciesArr[i]
              .replace('"', "")
              .replace('"', "");
          }
        }
      }

      /**
       * @param {Event} event
       */
      onMobileButtonClick(event) {
        event.preventDefault();
        if (!this.mobileVariantSwipersArray) {
          return;
        }

        for (const element of this.mobileVariantSwipersArray) {
          if (element.dataset.productId === this.productId) {
            element.classList.remove("swiper-variants-mobile-hidden");
          } else {
            element.classList.add("swiper-variants-mobile-hidden");
          }
        }
      }

      initSwiperUI() {
        if (window.innerWidth > 749) {
          this.initSwiperDesktop();
        } else {
          this.initSwiperMobile();
        }
      }

      /**
       * @param {Event} event
       */
      onResize(event) {
        if (event.target.innerWidth > 749) {
          this.initSwiperDesktop();
        } else {
          this.initSwiperMobile();
        }
      }

      closeAllMobileVariantSwipers() {
        if (!this.mobileVariantSwipersArray) {
          console.error("cannot find mobileVariantSwipersArray");
          return;
        }
        for (const element of this.mobileVariantSwipersArray) {
          element.classList.add("swiper-variants-mobile-hidden");
        }
      }

      initSwiperDesktop() {
        if (
          !this.swiperElementDesktop ||
          !this.swiperMobileButton ||
          !this.addToCartButton
        ) {
          // console.log("cannot find elements for swiper desktop");
          return;
        }
        this.closeAllMobileVariantSwipers();
        this.swiperMobileButton.style.display = "none";
        this.swiperElementDesktop.style.display = "flex";
        this.addToCartButton.removeEventListener(
          "click",
          this.boundOnMobileButtonClick
        );
      }

      initSwiperMobile() {
        if (
          !this.mobileVariantSwipersArray ||
          !this.swiperMobileButton ||
          !this.swiperElementDesktop ||
          !this.addToCartButton
        ) {
          // console.log("cannot find elements for swiper mobile");
          return;
        }
        this.closeAllMobileVariantSwipers();
        this.swiperMobileButton.style.display = "flex";
        this.swiperElementDesktop.style.display = "none";
        if (this.openModalToConfirmOnMobile) {
          this.addToCartButton.addEventListener(
            "click",
            this.boundOnMobileButtonClick
          );
        }
      }

      getVariantInventory() {
        const variantInventoryElement = this.querySelector(
          "#variant-quantities"
        );
        if (!variantInventoryElement) {
          console.error("cannot find variantInventoryElement");
          return;
        }
        this.variantInventoryArray = variantInventoryElement.textContent
          ? Array.from(variantInventoryElement.textContent.split("/"))
          : [];
        if (!this.product) {
          console.error("cannot find product");
          return;
        }
        if (this.isVariantCard && this.variantCardVariant) {
          this.variantCardVariant.inventoryQuantity = parseInt(
            this.variantInventoryArray[0]
          );
        }
        if (!this.isVariantCard) {
          for (let i = 0; i < this.product.variants.length; i++) {
            const variant = this.product.variants[i];
            variant.inventoryQuantity = parseInt(this.variantInventoryArray[i]);
          }
        }
      }

      /**
       * @param {string} shippingDate
       */
      setShipsBy(shippingDate) {
        window.postMessage({
          type: "update_ships_by_notification",
          productId: this.productId,
          shippingDate: knocking.calculateAbsoluteShippingDate(shippingDate),
        });

        if (this.shipsByInput) {
          this.shipsByInput.value = shippingDate;
        }
        if (!this.shipsByElementsArray) {
          console.error("cannot find shipsByElementsArray");
          return;
        }
        this.shipsByElementsArray.forEach((element) => {
          element.classList.remove("hidden");
        });
      }

      openExtendedOffer() {
        // console.log('openExtendedOffer');
        let selectedVariantId;
        if (this.isVariantCard && this.variantCardVariant) {
          selectedVariantId = this.variantCardVariant.id;
        } else if (this.variantInput) {
          selectedVariantId = parseInt(this.variantInput.value);
        } else if (this.product) {
          selectedVariantId = this.product.variants[0].id;
        } else {
          console.error("cannot find product");
        }

        const data = {
          product: this.product,
          selectedVariantId,
        };
        messenger.emmit(messenger.topics.OPEN_CP_EXTENDED_OFFER_MODAL, data);
      }

      /**
       * @param { Event } event
       **/
      extendedOfferHandler(event) {
        // console.log("handler: ", event.target.type);
        if (!event.target) {
          console.error("event.target is null");
          return;
        }
        if (event.target.type !== "button") {
          // Removing this return-statement for now, since it's causing the EventListener not to be attached when we have multiple variants, one option and all variants EO ... Refactor later!
          // return;
        }
        event.preventDefault();
        this.openExtendedOffer();
      }

      hideSoldOutElement() {
        if (!this.shipsByElementsArray || !this.soldOutElement) {
          console.error("cannot find shipsByElementArray");
          return;
        }
        if (this.shipsByElementsArray.length > 0) {
          this.soldOutElement.style.display = "none";
        } else {
          this.soldOutElement.style.display = "none";
        }
      }

      showSoldOutElement() {
        if (this.variantCardVariant) {
          // console.log("hideSoldOutElement", this.variantCardVariant.title);
        }

        if (!this.soldOutElement || !this.shipsByElementsArray) {
          console.error("cannot find necessary elements");
          return;
        }
        const hasVariantsDisplayed =
          this.product &&
          this.product.variants.length > 1 &&
          (this.variantInput ||
            this.swiperElementDesktop ||
            this.querySelector("variant-dropdown-cp"));
        const hasHolidayShippingParent = this.closest(
          ".holiday-shipping-enabled"
        );
        const hasHolidayShipping =
          this.holidayShippingEnable ||
          this.holidayShippingElement ||
          hasHolidayShippingParent;
        if (
          this.shipsByElementsArray.length > 0 ||
          hasHolidayShipping ||
          hasVariantsDisplayed
        ) {
          this.soldOutElement.style.display = "flex";
          this.soldOutElement.classList.add("overlap");
        } else {
          this.soldOutElement.style.display = "flex";
        }
      }

      setAddToCartButtonToSubmit() {
        if (!this.addToCartButton) {
          console.error("cannot find addToCartButton");
          return;
        }
        // console.log('setAddToCartButtonToSubmit');
        // console.log(
        //   'openModalToConfirmOnMobile: ',
        //   this.openModalToConfirmOnMobile
        // );
        // Deactivated for now, since we're not using the swipers right now, refactor later!
        // if (this.openModalToConfirmOnMobile) {
        //   return;
        // }
        this.addToCartButton.setAttribute("type", "submit");
      }

      setAddToCartButtonToButton() {
        if (!this.addToCartButton) {
          console.error("cannot find addToCartButton");
          return;
        }
        this.addToCartButton.setAttribute("type", "button");
        // console.log("Setting button to type button: ", this.addToCartButton);
      }

      /**
       * @param {number} variantId
       */
      updateProductUrls(variantId) {
        /**
         * @type {HTMLAnchorElement[] | null}
         */
        // console.log("variant id in update urls: ", typeof variantId);

        const aTags = Array.from(this.querySelectorAll("a"));
        // console.log("aTags: ", aTags);

        for (const tag of aTags) {
          // console.log("tag: ", tag);

          const oldUrl = tag.getAttribute("href")?.split("?")[0];
          if (oldUrl?.includes("product")) {
            tag.setAttribute(
              "href",
              `${oldUrl}?variant=${variantId.toString()}`
            );
          }
        }
      }

      resetButton() {
        if (!this.addToCartButton || !this.buyButtonText) {
          console.error("cannot find necessary elements");
          return;
        }
        this.addToCartButton.removeAttribute("disabled");
        this.addToCartButton.removeEventListener(
          "click",
          this.boundExtendedOfferHandler
        );
        this.hideSoldOutElement();
      }

      setAddToCartUI() {
        // console.log("setAddToCartUI for product :", this.product.title);
        if (!this.addToCartButton || !this.buyButtonText || !this.product) {
          console.error("cannot find necessary elements");
          return;
        }
        this.resetButton();

        this.addToCartButton.textContent = this.buyButtonText.addToCart;
        this.setShipsBy(knocking.getTagShippingDate(this.product.tags));
        this.showShipsBy();
        this.addToCartButton.removeAttribute("disabled");
        this.addToCartButton.type = "submit";
        const linkElement = this.addToCartButton.closest("a");
        if (linkElement) {
          linkElement.setAttribute("tabindex", "-1");
        }
      }

      setSoldOutUI() {
        // console.log("setSoldOutUI", this.product.title);
        if (!this.addToCartButton || !this.buyButtonText) {
          console.error("cannot find necessary elements");
          return;
        }
        if (this.holidayShippingElement) {
          this.holidayShippingElement.style.display = "none";
        }
        this.hideShipsBy();

        this.addToCartButton.textContent = this.buyButtonText.soldOut;
        this.showSoldOutElement();

        this.addToCartButton.removeAttribute("disabled");
      }

      setExtendedOfferUI(redirectToPP = false) {
        // console.log("setExtendedOfferUI", this.product.title);
        // console.log("redirectToPP: ", redirectToPP);
        // console.log('this.addToCartButton: ', this.addToCartButton);
        // console.log('this.buyButtonText: ', this.buyButtonText);

        if (!this.addToCartButton || !this.buyButtonText) {
          console.error("cannot find necessary elements");
          return;
        }
        this.resetButton();
        this.hideShipsBy();
        this.showSoldOutElement();

        this.addToCartButton.textContent = this.buyButtonText.extendedOffer;

        if (redirectToPP) {
          // console.log('adding event listener to extended offer button');
          this.addToCartButton.type = "button";
        } else {
          // console.log("removing event listener from extended offer button");
          this.addToCartButton.type = "submit";
          this.addToCartButton.addEventListener(
            "click",
            this.boundExtendedOfferHandler
          );
        }

        if (!this.shipsByElementsArray) {
          console.error("cannot find shipsByElementsArray");
          return;
        }

        this.shipsByElementsArray.forEach((element) => {
          element.classList.add("hidden");
        });

        if (this.holidayShippingElement) {
          this.holidayShippingElement.style.display = "none";
        }
      }

      setClickToBuyUI() {
        if (!this.addToCartButton || !this.buyButtonText || !this.product) {
          console.error("cannot find necessary elements");
          return;
        }
        this.resetButton();
        this.hideSoldOutElement();

        this.addToCartButton.textContent = this.buyButtonText.clickToBuy;
        if (!this.holidayShippingEnable) {
          this.setShipsBy(knocking.getTagShippingDate(this.product.tags));
          this.showShipsBy();
        }
        this.addToCartButton.type = "button";

        this.addToCartButton.removeAttribute("disabled");
      }

      setViewMoreUI() {
        // console.log("Setting ViewMore-UI");

        if (!this.addToCartButton || !this.buyButtonText || !this.product) {
          console.error("cannot find necessary elements");
          return;
        }
        this.resetButton();
        this.showSoldOutElement();
        this.hideShipsBy();

        this.addToCartButton.textContent = this.buyButtonText.viewMore;
        this.addToCartButton.type = "button";

        this.addToCartButton.removeAttribute("disabled");
      }

      hideShipsBy() {
        if (!this.shipsByElementsArray) {
          console.error("cannot find shipsByElementsArray");
          return;
        }
        this.shipsByElementsArray.forEach((element) => {
          element.style.display = "none";
        });
      }

      showShipsBy() {
        if (!this.shipsByElementsArray) {
          console.error("cannot find shipsByElementsArray");
          return;
        }
        this.shipsByElementsArray.forEach((element) => {
          element.style.display = "block";
        });
      }
    }
  );
}
